export const SIDE_NAV_HIDDEN_PATHS: readonly string[] = [
  '/impressum',
  '/datenschutz',
  '/imprint',
  'legal-notice',
  '/privacy-policy',
];
